import { render, staticRenderFns } from "./SplitDocumentOrMeteoType.vue?vue&type=template&id=6f8ab5d8&"
import script from "./SplitDocumentOrMeteoType.vue?vue&type=script&lang=js&"
export * from "./SplitDocumentOrMeteoType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports